import {FloteEndpointGroup} from "@/lib/api/endpoints/FloteEndpointGroup";

export class AssetsApi extends FloteEndpointGroup {
    public relativeUri: string = "assets";
}